module.exports = __webpack_public_path__ + "static/img/2-1c.f1bf49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m5/user-avtar/2-1c.png
// module id = 7Pfx
// module chunks = 1